<template>
    <div class="flex w-24 justify-center">
        <div
            :class="[
                isActive ? 'router-link-active' : '',
                'LeftNavItem Button relative inline-flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center overflow-visible rounded-lg',
            ]"
            @click="emit('click', $event)"
        >
            <span
                :class="{
                    'pointer-events-none -translate-x-3 opacity-0 duration-200': !isExpanded,
                    'pointer-events-auto opacity-100 duration-500': isExpanded,
                }"
                class="title absolute top-0 bottom-0 left-24 -ml-14 flex w-64 items-center pl-3 text-sm font-medium transition-all ease-out"
                >{{ item.title }}
                <span @click.stop>
                    <slot name="expander" />
                </span>
            </span>
            <span class="inline-flex h-6 w-6" aria-hidden="true">
                <slot />
            </span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true,
    },
    isExpanded: {
        type: Boolean,
        default: false,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['click'])
</script>

<style scoped>
@reference "@/tailwind.css";
.LeftNavItem.Button {
    @apply bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-700;
}
.LeftNavItem.Button .title {
    @apply text-slate-600 hover:text-slate-800;
}

.LeftNavItem.Button.router-link-active {
    @apply bg-brand-blue-50 text-brand-blue-700;
}
.LeftNavItem.Button.router-link-active .title {
    @apply text-brand-blue-800;
}
</style>
